import Network from 'infrastructure/js/modules/network';
import { api as messageDialogApi }  from '../../../MessageDialog/messageDialogActions.js';
import * as operationsService from '../../../../services/Operations/operationsService';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? operationsService.editOperation : operationsService.createOperation,
  },

  apiOverrides: {
    fetchDialogData(dispatch, getState) {
      return function () {
        return operationsService.getOperationTypes().then((response) => {
          if (!Network.isResponseValid(response)) {
            console.error('Fetch Operation Types', response);
            messageDialogApi.responseError(dispatch, getState)(response);
            return {success: false};
          }

          let dialogData = {
            operationTypes: response.dataList.map((obj) => {return {value: obj.id, label: obj.type, data: obj}}),
          };

          dispatch(actions.fetchDialogDataReady(dialogData));
          return {success: true};
        });
      }
    },
  },

});



// const config = {
//   getSubmitMethod: (submitConfigData) => {
//     return submitConfigData && submitConfigData.isEditMode ?
//       operationsService.editOperation : operationsService.createOperation;
//   }
// };
//
// export const actionTypes = {
//   ...commonActions.actionTypes,
// };
//
// const actions = {
//   ...commonActions.getActions(),
// };
//
// export let api = {
//   ...commonActions.getApiActions(actions, config),
//
//   fetchDialogData(dispatch, getState) {
//     return function() {
//       return operationsService.getOperationTypes().then((response) => {
//         if (!Network.isResponseValid(response)) {
//           console.error('Fetch Operation Types', response);
//           messageDialogApi.responseError(dispatch, getState)(response);
//           return {success: false};
//         }
//
//         let dialogData = {
//           operationTypes: response.dataList.map((obj) => {return {value: obj.id, label: obj.type, data: obj}}),
//         };
//
//         dispatch(actions.fetchDialogDataReady(dialogData));
//         return {success: true};
//       });
//     }
//   }
// };
//
// export let jsxActions = {
//   ...commonActions.getJsxActions(api),
// };

